import myaxios from "../../components/Axios";

export const getSingleAccountService = ({ id, expand }: { id: number, expand: string }) => myaxios.get(`/ajax/account/${id}?expand=${expand}`)
export const createAccountService = ({ data }: { data: any }) => myaxios.post(`/ajax/account`, data)
export const updateAccountService = ({ id, data }: { id: number, data: any }) => myaxios.put(`/ajax/account/${id}`, data)
export const deleteAccountService = ({ id }: { id: number }) => myaxios.delete(`/ajax/account/${id}`)